<template>
  <main>
    <b-container>
      <div class="section-header">
        <h1 class="heading">Projects</h1>

        <div class="actions">
          <div class="action">
            <b-form-select v-model="tag" :options="tagSelect"></b-form-select>
          </div>
          <div class="action">
            <b-form-input v-model="search" placeholder="Search…"></b-form-input>
          </div>
          <div class="action">
            <b-btn
               v-if="isAuthenticatedUserHasAccess"
              variant="primary"
              @click="isProjectAllowed()"
              ><i class="fa fa-plus" /> New project</b-btn
            >
            <CustomAlert
              :visible="showAlert"
              title="Limit Exceeded"
              message="You have reached the usage limit of your company subscription plan.
              To extend it, please contact us at info@mynd-ware.com"
              @close="showAlert = false"
              />
          </div>
        </div>
      </div>

      <b-row v-if="isAuthenticatedUserHasAccess && realmSettings" class="layoutcard lessmargin mt-4 ml-0 mr-0">
        <b-col cols="12" class="d-flex align-items-start pb-2">
          <h3>Welcome {{realmSettings.clientname || ""}}!</h3>
          <b-badge v-if="realmSettings.clientType === 'limited'" variant="secondary-orange" class="ml-2 text-white">Limited</b-badge>
          <b-badge v-else variant="primary-cyan" class="ml-2">UnLimited</b-badge>
          <span class="ml-auto">{{ realmSettings.signupDate || "NA" | moment("DD-MM-YYYY") }} - {{ Date.now() | moment("DD-MM-YYYY") }}</span>
        </b-col>
        <b-col class="pl-0">
          <div class="layoutcard with-topborder">
            <h6 class="text-muted">Projects</h6>
            <h1 class="mb-0" v-html="getStats()[0]"></h1>
          </div>
        </b-col>
        <b-col>
          <div class="layoutcard with-topborder">
            <h6 class="text-muted">Models</h6>
            <h1 class="mb-0" v-html="getStats()[1]"></h1>
          </div>
        </b-col>
        <b-col>
          <div class="layoutcard with-topborder">
            <h6 class="text-muted">Pools</h6>
            <h1 class="mb-0" v-html="getStats()[2]"></h1>
          </div>
        </b-col>
        <b-col class="pr-0">
          <div class="layoutcard with-topborder">
            <h6 class="text-muted">Storage</h6>
            <h1 class="mb-0" v-html="getStats()[3]"></h1>
          </div>
        </b-col>
      </b-row>

      <div class="layoutcard">
        <!-- This table is for loading placeholders.
        Use this when you implement lazy loading. -->
        <!-- <table class="table table-hover vertical-align-middle">
          <thead>
            <tr>
              <th>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </th>
              <th>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </th>
              <th>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </th>
              <th>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </th>
              <th>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </th>
              <th>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
              <td>
                <div class="placeholder">
                  <div class="placeholder__tile"></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table> -->

        <b-table
          :show-empty="true"
          :items="projectsFiltered"
          :fields="fields"
          :filter="search"
          :current-page="currentPage"
          :per-page="perPage"
          class="table-hover vertical-align-middle"
          @filtered="onFiltered"
        >
          <template v-slot:cell(name)="data">
            <router-link
              :to="{ name: 'ProjectView', params: { id: data.item._id } }"
              >{{ data.item.name }}</router-link
            >
          </template>
          <template v-slot:cell(owner)="data">
            <b-badge variant="light">{{ data.item.users[0].user }}</b-badge>
          </template>
          <template v-slot:cell(description)="data">
            <div class="text-fix" :title="data.item.description">
              {{ data.item.description }}
            </div>
          </template>
          <template v-slot:cell(tag)="data">
            <b-badge variant="light">{{ data.item.tag }}</b-badge>
          </template>
          <template v-slot:cell(modificationdate)="data">
            {{ data.item.lastModified | moment("DD-MM-YYYY") }}
          </template>
          <template v-slot:cell(creationdate)="data">
            {{ data.item.creationDate | moment("DD-MM-YYYY") }}
          </template>
        </b-table>

        <b-row align-h="center" class="mt-4" v-if="totalRows > perPage">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
          ></b-pagination>
        </b-row>
      </div>

      <!-- <b-row>
        <b-col class="text-right">
          <b-btn
            variant="primary"
            size="lg"
            @click="$router.push({ name: 'ProjectCreate' })"
            ><i class="fa fa-plus" /> New project</b-btn
          >
        </b-col>
      </b-row> -->
    </b-container>
  </main>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";
import InitAdmin from "../Shared/InitAdmin";
import CustomAlert from "../Shared/CustomAlert.vue";

export default {
  name: "ProjectIndex",
  extends: InitAdmin,
  components:{
    CustomAlert
  },
  data() {
    return {
      showAlert: false,
      search: "",
      currentPage: 1,
      perPage: 10,
      tag: null,
      fields: [
        {
          key: "name",
        },
        {
          key: "owner",
        },
        {
          key: "description",
        },
        {
          key: "tag",
        },
        {
          key: "modificationdate",
          thClass: "text-right",
          tdClass: "text-right",
          label: "Date Modified",
        },
        {
          key: "creationdate",
          tdClass: "text-right",
          thClass: "text-right",
          label: "Creation Date",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      realmSettings: (state) => state.setting.realmSettings
    }),
    ...mapGetters(["isAuthenticatedUserHasAccess", "projectsByDateDesc"]),
    totalRows() {
      return this.projectsByDateDesc.length;
    },
    tagSelect() {
      //let tags = _.uniq(this.projectsByDateDesc.map((p) => p.tag));
      let tags = _.uniq(
        this.projectsByDateDesc
          .map((p) => p.tag)
          .toString()
          .split(",")
      );
      return [{ value: null, text: "Select tag" }, ...tags];
    },
    projectsFiltered() {
      if (this.tag) {
        return this.projectsByDateDesc.filter((p) => p.tag.includes(this.tag));
      }
      return this.projectsByDateDesc;
    },
  },
  mounted() {
    this.loadProjects();
  },
  methods: {
    ...mapActions(["loadProjects", "deleteProject"]),
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getStats(){
      let stats = [];
      if(this.realmSettings.maxAllProjects && this.realmSettings.maxAllProjects !== ""){
        stats[0] = this.realmSettings.total_projects_created+" / "+this.realmSettings.maxAllProjects;
      }
      else{
        stats[0] = this.realmSettings.total_projects_created+" / <i class='fas fa-infinity'></i>";
      }
      if(this.realmSettings.maxAllModelsByProject && this.realmSettings.maxAllModelsByProject !== ""){
        stats[1] = this.realmSettings.total_models_created+" / "+this.realmSettings.maxAllModelsByProject;
      }
      else{
        stats[1] = this.realmSettings.total_models_created+" / <i class='fas fa-infinity'></i>";
      }
      if(this.realmSettings.maxAllPools && this.realmSettings.maxAllPools !== ""){
        stats[2] = this.realmSettings.total_pools_created_+" / "+this.realmSettings.maxAllPools;
      }
      else{
        stats[2] = this.realmSettings.total_pools_created_+" / <i class='fas fa-infinity'></i>";
      }
      if(this.realmSettings.maxAllPoolStorageMb && this.realmSettings.maxAllPoolStorageMb !== ""){
        stats[3] = this.realmSettings.total_file_storage.toFixed(2)+" / "+this.realmSettings.maxAllPoolStorageMb;
      }
      else{
        stats[3] = this.realmSettings.total_file_storage.toFixed(2)+" / <i class='fas fa-infinity'></i>";
      }
      return stats; 
    },
    isProjectAllowed(){
      if (this.realmSettings.total_projects_created == parseInt(this.realmSettings.maxAllProjects) || this.realmSettings.total_projects_created > parseInt(this.realmSettings.maxAllProjects) ){
        this.showAlert = true;
        return;
      }
      
      this.$router.push({ name: 'ProjectCreate' })
    }
  },
};
</script>
